import { api } from "@/lib/api";

// Converts the VAPID public key (base64url, no padding) the backend hands
// out into the raw Uint8Array PushManager.subscribe() expects.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return bytes;
}

/**
 * Best-effort: subscribes this device to Web Push so the backend can ring
 * it (default notification sound + vibration) for things like a newly
 * assigned task, even while the app is closed. Silently no-ops on browsers
 * without push support, and never throws — this is a background nicety,
 * not something that should block or nag whoever's using the app.
 */
export async function ensurePushSubscribed() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (Notification.permission === "denied") return;

    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      const { data } = await api.get("/push/public-key");
      if (!data?.public_key) return;
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    }

    await api.post("/push/subscribe", subscription.toJSON());
  } catch {
    /* best-effort — permission denied, unsupported browser, etc. */
  }
}
